require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-roadmap-to-nowhere-wbg-evolution-plan-falls-short.json") })
        }
      }, "path---en-us-update-roadmap-to-nowhere-wbg-evolution-plan-falls-short");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-roadmap-to-nowhere-wbg-evolution-plan-falls-short!./.cache/json/en-us-update-roadmap-to-nowhere-wbg-evolution-plan-falls-short.json
// module id = 789
// module chunks = 231608221292675